/* 
	Keeping example comments here short but you get the idea
	Import custom typography objects from component styles
	and merge them into the main typography object
	If your typography is "limited" to the component it resides in, no need to pass it here
	IMPORTANT: DONT import the main theme (src/utils/theme.js) here as it causes circular dependency issues
	Instead, create the theme object here as needed, and pass it to the custom typography functions
*/

import { createTheme } from '@mui/material/styles';
// import { customTypographyExample, customTypographyExampleBreakpoints } from 'components/Example/styles';
import breakpoints from 'utils/breakpoints';

import { getColor } from 'utils/colors';
import { remCalc } from 'utils/remCalc';

import mergeDeep from './mergeDeep';

const theme = createTheme({
	breakpoints: breakpoints,
});

// const customTypography = mergeDeep(
// 	customTypographyExample,
// 	customTypographyExampleBreakpoints(theme),
// )

export const typography = mergeDeep({
	typography: {
		htmlfontSize: 10,
		fontSize: 8.75, // Not 100% sure why this isn't set exactly, but whatever the size is set to here, it's actually 1.82857 times larger. Setting htmlFontSize to 16 makes this factor smaller, but not 1. So, it's related, but not sure how.
		fontFamily: 'var(--body-font)',

		display: {
			fontFamily: 'var(--heading-font)',
			fontSize: remCalc(48),
			fontWeight: 400,
			lineHeight: remCalc(50),
			letterSpacing: 2,
			textTransform: 'uppercase',
			[theme.breakpoints.up('ms')]: {
				fontSize: remCalc(100),
				lineHeight: remCalc(92),
				letterSpacing: 2,
			},
		},
		h1: {
			fontFamily: 'var(--heading-font)',
			fontSize: remCalc(32),
			fontWeight: 400,
			lineHeight: remCalc('40px'),
			letterSpacing: 0.5,
			textTransform: 'uppercase',
			[theme.breakpoints.up('ms')]: {
				fontSize: remCalc(54),
				lineHeight: remCalc(67),
				letterSpacing: -2,
			},
		},
		h2: {
			fontFamily: 'var(--heading-font)',
			fontSize: remCalc(28),
			fontWeight: 400,
			lineHeight: remCalc('32px'),
			letterSpacing: 0.5,
			[theme.breakpoints.up('ms')]: {
				fontSize: remCalc(49),
				lineHeight: remCalc(67),
			},
		},
		h3: {
			fontFamily: 'var(--heading-font)',
			fontSize: remCalc(26),
			fontWeight: 400,
			lineHeight: remCalc('32px'),
			letterSpacing: 0.5,
			[theme.breakpoints.up('ms')]: {
				fontSize: remCalc(39),
				lineHeight: remCalc('47px'),
			},
		},
		h4: {
			fontFamily: 'var(--heading-font)',
			fontSize: remCalc(23),
			fontWeight: 500,
			lineHeight: remCalc('28px'),
			letterSpacing: 0.5,
			[theme.breakpoints.up('ms')]: {
				fontSize: remCalc(32),
				lineHeight: remCalc('40px'),
			},
		},
		h5: {
			fontFamily: 'var(--heading-font)',
			fontSize: remCalc(20),
			fontWeight: 500,
			lineHeight: remCalc('26px'),
			letterSpacing: 0.5,
			[theme.breakpoints.up('ms')]: {
				fontSize: remCalc(25),
				lineHeight: remCalc('32px'),
			},
		},
		h6: {
			fontFamily: 'var(--heading-font)',
			fontSize: remCalc(18),
			fontWeight: 500,
			lineHeight: remCalc('24px'),
			letterSpacing: 0.5,
			[theme.breakpoints.up('ms')]: {
				fontSize: remCalc(20),
				lineHeight: remCalc('26px'),
			},
		},
		h_small: {
			fontFamily: 'var(--heading-font)',
			fontSize: remCalc(14),
			fontWeight: 400,
			lineHeight: remCalc('18px'),
			letterSpacing: remCalc('.28px'),
			[theme.breakpoints.up('ms')]: {
				fontSize: remCalc(14),
				lineHeight: remCalc('18px'),
			},
		},
		body1: {
			fontFamily: 'var(--body-font)',
			fontWeight: 500,
			fontSize: remCalc(16),
			lineHeight: remCalc(22),
			letterSpacing: 0.5,
		},
		body2: {
			fontFamily: 'var(--body-font)',
			fontWeight: 500,
			fontSize: remCalc(14),
			lineHeight: remCalc('20px'),
			letterSpacing: 0.5,
		},
		large: {
			fontFamily: 'var(--body-font)',
			fontWeight: 700,
			fontSize: remCalc(24),
			lineHeight: remCalc('32px'),
			letterSpacing: 0.5,
		},
		link: {
			fontFamily: 'var(--font-brandon-grotesque)',
			fontWeight: 700,
			color: getColor('blue', 400),
			textDecorationColor: getColor('blue', 400),
			transitionDuration: 'var(--transition-duration)',
			wordBreak: 'break-word',
			'&:hover': {
				color: getColor('blue', 900),
			},
		}
	}
}, /* customTypography */);